import React from "react";
import { useSelector } from "react-redux";

import LoginByPassComponent from "./loginByPassComponent";
import LoginBySms from "./loginBySms";

export default function Login({ props }) {
  const loginDetail = useSelector((state) => state.loginDetail);

  switch (loginDetail.typeLogin) {
    case 0:
      return <LoginBySms props={props} />;
    case 1:
      return <LoginByPassComponent />;
    default:
      return <LoginByPassComponent />;
  }
}
